<div class="relative flex h-auto min-h-screen w-full flex-col group/design-root overflow-x-hidden bg-background-light dark:bg-background-dark dark:text-white">
  <div class="layout-container flex h-full grow flex-col w-full">
  <app-header *ngIf="router.url !== '/login'"></app-header>
  <app-side-nav *ngIf="router.url !== '/dashboard' && router.url !== '/login'"></app-side-nav>
  <div class="ml-0 bg-background-light dark:bg-background-dark dark:text-white" [ngClass]="{'lg:ml-64 p-8': (router.url !== '/dashboard' && router.url !== '/login'), 'p-0': router.url === '/dashboard' || router.url === '/login'}">
      <router-outlet></router-outlet>
    </div>
  </div>

  <!-- Coming Soon overlay removed for production -->
</div>
